import { useEffect, useState } from "react";
import axios from "axios";
import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import FloatingButtons from "@/components/FloatingButtons";
import Menu from "@/components/Menu";
import Reveal from "@/components/Reveal";
import { resolveContent } from "@/lib/images";

const API = `${process.env.REACT_APP_BACKEND_URL || 'https://smapi.sanmartino26.al'}/api`;

const MenuPage = () => {
  const [content, setContent] = useState(null);

  useEffect(() => {
    document.title = "Menu — San Martino 26";
    window.scrollTo(0, 0);
    let cancelled = false;
    axios.get(`${API}/content`).then((res) => {
      if (!cancelled) setContent(resolveContent(res.data));
    }).catch(() => { });
    return () => { cancelled = true; };
  }, []);

  return (
    <main data-testid="menu-page" className="bg-transparent text-sm-text min-h-screen flex flex-col">
      <Navigation brand={content?.brand} />

      <section className="flex-1 pt-32 pb-24 md:pt-48 md:pb-36 sm-grain px-6 flex flex-col justify-center">
        <div className="sm-container max-w-4xl mx-auto flex flex-col items-center text-center">
          <Reveal>
            <h1 className="font-serif text-5xl md:text-6xl lg:text-7xl italic font-light text-sm-text mb-6 leading-tight">
              Menuja Jonë
            </h1>
          </Reveal>

          <Reveal delay={0.1}>
            <p className="sm-eyebrow mb-12">Një ftesë për zbulim dhe udhëtim</p>
          </Reveal>

          <Reveal delay={0.2}>
            <div className="space-y-6 text-sm md:text-base text-sm-muted font-light leading-relaxed max-w-2xl mx-auto mb-16">
              <p>
                Mirësevini në San Martino 26, restoranti ku menuja do t'ju udhëheqë në një udhëtim unik kulinar. Çdo pjatë tregon një histori kreativiteti, duke festuar lëndët e para më të mira dhe traditat e riinterpretuara në një këndvështrim modern.
              </p>
              <p>
                A jeni gati të përjetoni një përvojë të paharrueshme gastronomike? Çdo krijim lind nga një ide e saktë, nga një kërkim i vazhdueshëm dhe nga dëshira për të propozuar një tregim bashkëkohor, plot shije dhe origjinalitet. Përbërësit që zgjedhim janë sezonalë, të përzgjedhur me kujdes ekstrem dhe të përpunuar me respekt, për të shprehur më mirë karakteristikat e tyre, pa kompromise.
              </p>
              <p>
                Kuzhina jonë është një kuzhinë bashkëkohore që vlerëson territorin, bashkon teknikën dhe ndjeshmërinë, dhe ndryshon me stinët. Rrugëtimet tona të degustimit përfaqësojnë vizionin tonë më autentik: një udhëtim në shije që evoluon me kalimin e kohës, duke mbetur besnik ndaj asaj që jemi.
              </p>
            </div>
          </Reveal>

          <Reveal delay={0.3}>
            <div className="flex flex-col sm:flex-row gap-6 items-center justify-center w-full max-w-lg mx-auto">
              <a
                href={content?.menu?.pdf_url || "#"}
                target="_blank"
                rel="noreferrer"
                className="w-full sm:w-auto px-12 py-4 border border-sm-border text-[0.7rem] tracking-[0.32em] uppercase text-sm-text text-center hover:bg-sm-surface transition-colors"
              >
                MENU
              </a>
              <a
                href={content?.menu?.wine_pdf_url || "#"}
                target="_blank"
                rel="noreferrer"
                className="w-full sm:w-auto px-12 py-4 border border-sm-border text-[0.7rem] tracking-[0.32em] uppercase text-sm-text text-center hover:bg-sm-surface transition-colors"
              >
                WINE MENU
              </a>
            </div>
          </Reveal>

          <Reveal delay={0.4}>
            <div className="mt-12">
              <a
                href="/#rezervo"
                className="inline-block px-10 py-4 bg-sm-olive text-sm-bg text-[0.75rem] tracking-[0.32em] uppercase font-medium hover:bg-opacity-90 transition-opacity"
              >
                Rezervo
              </a>
            </div>
          </Reveal>
        </div>
      </section>

      {content?.menu && <Menu content={content.menu} />}

      {content && <Footer content={content.footer} />}
      <FloatingButtons number={content?.brand?.whatsapp_number} />
    </main>
  );
};

export default MenuPage;
